<template>
    <main id="main">
        <section id="services" :class="['services', 'pb-1', 'mb-1']">
            <div :class="['container']">
                <div :class="['row']">
                    <div :class="['col-lg-12', 'col-md-12', 'icon-box']">
                        <div :class="['card', 'borderTopCard', 'shadow-sm']" >
                            <div :class="['card-body', 'pt-2']">
                                <h3 :class="['card-title', 'text-left', 'font-weight-bold', 'pb-0', 'mb-3']">Noticias</h3>
                                <hr :class="['mt-1', 'mb-3']">

                                <div :class="['row']">
                                    <div v-for="(val, key) in Noticias" :key="key" class="col-lg-3 mb-4">
                  			            <div :class="['card']">
                                            <router-link :to="'/noticia/'+val.id">
                                                <img :class="['card-img-top']" style="height: 10rem;" :src="val.path_file_imagen" alt="">
                                            </router-link>
                                            <div :class="['entry-meta', 'bg_color_drasam']"> 
                                                <div :class="['date']">
                                                    <span :class="['fa', 'fa-calendar', 'mr-2']"></span>
                                                    <p><span style="text-transform: capitalize" :class="['mr-2']">{{obtenerNombreMes(val.mes)}}</span> {{val.dia}} de {{val.anio}}</p>
                                                </div>
                                                
                                                <span :class="['rounded-bend']"></span>
                                            </div>
							                <div :class="['card-body']">
							                    <h5 class="titulo_noticia" :title="val.titulo" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                                                    <b>
                                                        <router-link :to="'/noticia/'+val.id">{{val.titulo}}</router-link>
                                                    </b>
                                                </h5>
							                    <p class="card-text text-justify">
							                        {{(val.contenido_text).slice(0, 60)+'...'}}
                                                </p>
							                    <router-link :to="'/noticia/'+val.id" class="btn btn-link btn-sm">Leer más</router-link>
							                </div>
							            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
    			   	<div class="col-lg-12">
    			   		<nav aria-label="Page navigation example">
						    <ul class="pagination justify-content-center">
                                <li :class="['page-item', (pag<=1)?'disabled':'']">
						            <router-link class="page-link" :to="'/noticias/1'" >Primera pagina</router-link>
						        </li>
						        <li :class="['page-item', (pag<=1)?'disabled':'']">
						            <router-link class="page-link" :to="'/noticias/'+pag_anterior" >Anterior</router-link>
						        </li>
                                <span :class="['mr-4', 'ml-4']">Pagina {{pag}}</span>
                                <!--
						        <li class="page-item"><a class="page-link" href="#">1</a></li>
						        <li class="page-item"><a class="page-link" href="#">2</a></li>
						        <li class="page-item"><a class="page-link" href="#">3</a></li>
                                -->
						        <li :class="['page-item', (pag==total_paginas)?'disabled':'']">
						            <router-link class="page-link" :to="'/noticias?pag='+pag_siguiente" >Siguiente</router-link>
						        </li>
                                <li :class="['page-item', (pag==total_paginas)?'disabled':'']">
						            <router-link class="page-link" :to="'/noticias?pag='+total_paginas" >Ultima pagina</router-link>
						        </li>
						    </ul>
						</nav>
    			   	</div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';
    export default {
        name: 'Noticias',
        computed:{
            ...mapState(['loading','globales','empresa']),
        },
        mounted(){
            //console.log(this.$route.query);
            this.loadObjEmpresa();
            document.title = "Noticias || "+this.empresa.abreviatura;
            this.pag_anterior = parseInt((this.pag)) -  1;
            this.pag_siguiente = parseInt((this.pag)) + 1;
            this.getData();
        },
        data(){
            return{
                pag: (this.$route.query.pag)?this.$route.query.pag:1,
                Noticias:[],
                pag_anterior:1,
                pag_siguiente:1,
                total_paginas :1,
            }
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa']),
            getData(){
                this.setLoading(true);
                
                this.$http.get('webserviceserver/notas_prensa?pag='+this.pag).then((res)=>{
                    this.Noticias   = res.data.News;
                    this.total_paginas = res.data.pag + 1;
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
        },
    }
</script>

<style scoped>
    
</style>